.b6{max-width:100%;}